
export const TOKEN_KEY = "@Connect-Token";
export const defaultKey = () => localStorage.getItem(TOKEN_KEY);
export const login = token => {
    localStorage.setItem(TOKEN_KEY, token);
};
export const logout = () => {
    localStorage.removeItem(TOKEN_KEY);
};


export const getUser = () => {
    if (defaultKey() !== null) {
        return JSON.parse(defaultKey());
    }
};

export const getToken = () => {
    if (defaultKey() !== null) {
        const {token} = JSON.parse(defaultKey());
        return token;
    }
}